import React from 'react'
import { Checkbox, Icon } from 'semantic-ui-react'
import { useThemeMode } from 'hooks/useThemeMode'
import './ThemeModeButton.css'

const ThemeModeButton = () => {
	const { isDarkMode, toggleThemeMode } = useThemeMode()
	const modeText = isDarkMode ? 'Modo Oscuro' : 'Modo Claro'

	return (
		<div className='ThemeModeButton'>
			<Checkbox
				toggle
				checked={isDarkMode}
				onChange={toggleThemeMode}
				aria-label={isDarkMode ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'}
			/>
			<div className='ThemeModeButton__status' aria-live='polite'>
				<span>{modeText}</span>
				<Icon
					name={isDarkMode ? 'moon outline' : 'sun'}
					className={isDarkMode ? 'ThemeModeButton__icon' : 'ThemeModeButton__icon ThemeModeButton__icon--sun'}
					aria-hidden='true'
				/>
			</div>
		</div>
	)
}

export default ThemeModeButton
